import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonWithGAClickButton,
  CardGrid,
  CardMedia,
  List,
  ListItem,
  MediaCard,
  MediaCardContent,
  MediaCardTitle,
  Section,
  SectionSubTitle,
} from 'common/components';
import { createElementKey } from 'utils';
import { CEILINGS_ELEMENT_BLOCK } from '../../ceilings-constants';
import { CEILING_TYPES_CARD_LIST } from './ceilings-types-section-constants';
import {
  ceilingsTypesCardButton,
  ceilingsTypesCardContent,
  ceilingsTypesCardDescriptionList,
  ceilingsTypesCardGrid,
  ceilingsTypesCardImage,
  ceilingsTypesCardTitle,
} from './ceilings-types-section-styles';

type CeilingsTypesSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const CeilingsTypesSection = ({ onConsultationSignupBtnClick }: CeilingsTypesSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionSubTitle margin="m">{t('types-section.title')}</SectionSubTitle>
      <CardGrid className={ceilingsTypesCardGrid}>
        {CEILING_TYPES_CARD_LIST.map(({ title, descriptionList, alt, imgSrc }, index) => (
          <MediaCard key={createElementKey('ceilings-types-card', index)}>
            <CardMedia alt={t(alt) || ''} className={ceilingsTypesCardImage} src={imgSrc} />
            <MediaCardContent className={ceilingsTypesCardContent}>
              <MediaCardTitle adaptive={false} className={ceilingsTypesCardTitle}>
                {t(title)}
              </MediaCardTitle>
              <List className={ceilingsTypesCardDescriptionList}>
                {descriptionList.map(({ className, leftIcon, text }, listIndex) => (
                  <ListItem
                    className={className}
                    key={createElementKey('ceilings-types-description', listIndex)}
                    leftIcon={leftIcon}
                    text={t(text) || ''}
                  />
                ))}
              </List>
              <ButtonWithGAClickButton
                className={ceilingsTypesCardButton}
                elementBlock={CEILINGS_ELEMENT_BLOCK}
                elementName={title}
                elementText={t('types-section.button')}
                onClick={onConsultationSignupBtnClick}>
                {t('types-section.button')}
              </ButtonWithGAClickButton>
            </MediaCardContent>
          </MediaCard>
        ))}
      </CardGrid>
    </Section>
  );
}
